import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.9994 2C9.44628 2 8.9994 2.44687 8.9994 3V3.6C6.71815 4.0625 4.9994 6.08125 4.9994 8.5V9.0875C4.9994 10.5562 4.45878 11.975 3.48378 13.075L3.25253 13.3344C2.99003 13.6281 2.92753 14.05 3.0869 14.4094C3.24628 14.7688 3.60565 15 3.9994 15H15.9994C16.3932 15 16.7494 14.7688 16.9119 14.4094C17.0744 14.05 17.0088 13.6281 16.7463 13.3344L16.515 13.075C15.54 11.975 14.9994 10.5594 14.9994 9.0875V8.5C14.9994 6.08125 13.2807 4.0625 10.9994 3.6V3C10.9994 2.44687 10.5525 2 9.9994 2ZM11.415 17.4156C11.79 17.0406 11.9994 16.5312 11.9994 16H9.9994H7.9994C7.9994 16.5312 8.20878 17.0406 8.58378 17.4156C8.95878 17.7906 9.46815 18 9.9994 18C10.5307 18 11.04 17.7906 11.415 17.4156Z",
		fill: "#0D2976"
	})
});
export default SvgBell;
